import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import AdminIcon from "Assets/svg/icon/admin.svg";
import UserIcon from "Assets/svg/icon/user.svg";

import { ReactSVG } from "react-svg";
import { Assignment } from "@material-ui/icons";
import Translator from "Languages/Utility/Translator";
function HistoryTypeFormatter({ type }) {
  return (
    <div className="isGFormatter">
      {type === 1 && (
        <Tooltip title={<Translator id='createdByUser' noSpan />} placement="bottom">
          <ReactSVG src={UserIcon} className="justIcon normalUserIcon" />
        </Tooltip>
      )}
      {type === 2 && <Assignment className="requestUser" />}
      {type === 3 && (
        <Tooltip title={<Translator id='createdByAdmin' noSpan />} placement="bottom">
          <ReactSVG src={AdminIcon} className="justIcon adminIcon" />
        </Tooltip>
      )}
    </div>
  );
}

export default HistoryTypeFormatter;
